import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "./ThemeProvider";

const MODES = [
  { id: "light", icon: Sun, label: "Light" },
  { id: "dark", icon: Moon, label: "Dark" },
  { id: "system", icon: Monitor, label: "System" },
];

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="theme-switcher" role="group" aria-label="Theme">
      {MODES.map((m) => {
        const Icon = m.icon;
        return (
          <button
            key={m.id}
            type="button"
            className={`theme-switcher-btn ${theme === m.id ? "active" : ""}`}
            onClick={() => setTheme(m.id)}
            title={m.label}
            aria-label={m.label}
            aria-pressed={theme === m.id}
          >
            <Icon size={16} strokeWidth={1.75} />
          </button>
        );
      })}
    </div>
  );
}
